import { restGet, restPost, idForPath } from "./restClient.js";
import { bytesBase64ToUuid, pick } from "./reviewClient.js";

export const NOTIFICATION_TYPES = Object.freeze([
    ["NEW_FINDING", "New findings", "Every new finding you can view", "Findings"],
    ["FINDING_ASSIGNED", "Findings assigned to me", "Selected findings assigned to you", "Assignments"],
    ["INVESTIGATION_ASSIGNED", "Investigations assigned to me", "Existing investigations assigned to you", "Assignments"],
    ["JIT_SUBMITTED", "JIT requests submitted", "Requests you can review", "Temporary access"],
    ["JIT_GRANTED", "JIT access granted", "Your access grants, or grants you administer", "Temporary access"],
    ["JIT_DENIED", "JIT requests denied", "Decisions on your requests", "Temporary access"],
    ["JIT_CANCELLED", "JIT requests cancelled", "Your withdrawn requests, or requests you can review", "Temporary access"],
    ["JIT_REVOKED", "JIT access revoked", "Your access revoked, or revocations you administer", "Temporary access"],
    ["JIT_EXPIRED", "JIT access expired", "Your access expired, or expirations you administer", "Temporary access"],
].map(([key, label, description, group], i) => Object.freeze({ kind: `NOTIFICATION_KIND_${key}`, number: i + 1, label, description, group })));
export const notificationType = (kind) => NOTIFICATION_TYPES.find((t) => t.kind === kind || t.number === Number(kind));

export async function listUserNotifications({ pageToken = "", unreadOnly = false, kind = "", pageSize = 50, signal } = {}) {
    const query = new URLSearchParams({ pageSize: String(pageSize), unreadOnly: String(unreadOnly) });
    if (pageToken) query.set("pageToken", pageToken);
    if (kind) query.set("kind", kind);
    const raw = await restGet(`/v1/user-notifications?${query}`, null, { signal });
    return {
        notifications: (raw.notifications || []).map((n) => ({
            id: pick(n, "notification_id", "notificationId"), kind: notificationType(n.kind)?.kind || "", title: n.title,
            occurredAt: pick(n, "occurred_at", "occurredAt"), read: !!n.read,
            objectId: bytesBase64ToUuid(pick(n, "object_id", "objectId")),
            traceId: bytesBase64ToUuid(pick(n, "trace_id", "traceId")),
        })),
        nextPageToken: pick(raw, "next_page_token", "nextPageToken") || "",
        unreadCount: Number(pick(raw, "unread_count", "unreadCount") || 0),
        readBoundary: pick(raw, "read_boundary", "readBoundary") || "",
    };
}
export const updateUserNotification = (id, change) => restPost(`/v1/user-notifications/${idForPath(id)}:update`, change);
export const markUserNotificationsRead = (readBoundary) => restPost("/v1/user-notifications:markRead", { readBoundary });
export const getUserNotificationPreferences = ({ signal } = {}) => restGet("/v1/user-notification-preferences", null, { signal });
export const updateUserNotificationPreferences = (kind, enabled) => restPost("/v1/user-notification-preferences:update", { preferences: [{ kind, enabled }] });
